/* ============================================================
   VersionApp — pied de page indiquant la version déployée.

   Sert à répondre d'un coup d'œil, depuis un téléphone, à « est-ce que
   j'ai bien récupéré le dernier build ? » : le service worker peut servir
   une version en cache, c'est justement ce que cette ligne révèle.

   Source : `shared/brand/VersionApp/`.
   Copié dans `packages/<app>/src/components/`
   (CRA n'autorise pas les imports hors de src/) — modifier la source
   **et** les copies.

   Valeurs injectées au build par `scripts/build.sh` :
     - REACT_APP_VERSION    version du package.json de l'app
     - REACT_APP_BUILD_DATE date du build, lisible
     - REACT_APP_BUILD_ID   horodatage epoch, qui sert aussi de nom de
                            cache au service worker (affiché en infobulle)
   `yarn start` n'en injecte aucune : on affiche alors « dev », pour qu'un
   écran de développement ne se fasse pas passer pour un build déployé.

   Props :
     - className: string (classes supplémentaires)
     - style:     object (surcharge du style par défaut)
   ============================================================ */
import React from 'react';

const STYLE_PAR_DEFAUT = {
  flexShrink: 0,
  padding: '4px 8px',
  textAlign: 'center',
  fontSize: '10px',
  lineHeight: 1.4,
  color: '#94a3b8',
};

export default function VersionApp({ className = '', style }) {
  const version = process.env.REACT_APP_VERSION;
  const date = process.env.REACT_APP_BUILD_DATE;
  const buildId = process.env.REACT_APP_BUILD_ID;

  return (
    <div
      className={`bh-version ${className}`.trim()}
      style={{ ...STYLE_PAR_DEFAUT, ...style }}
      title={buildId ? `Build ${buildId}` : 'Build local (yarn start)'}
    >
      {version ? `v${version}` : 'dev'}
      {date ? ` · ${date}` : ''}
    </div>
  );
}
